import { DomainSwitch } from "../../_components/Abstractions/DomainSwitch";
import { GenerateOrderBaseReport } from "./GenerateOrderBaseReport";
import { reportsActions } from "../../_store/reports.slice";

export function GenerateGroupContainerUsageReport() {
  const customFormControls = <>
    <DomainSwitch name="isDetailed" label="Szczegółowy raport"/>
  </>;

  const renderData = () => {};

  return <GenerateOrderBaseReport
    reportTitle="Zużycie kontenerów (grupy)"
    reportType="groupContainersUsage"
    reportAction={reportsActions.generateGroupContainersUsageReport}
    renderData={renderData}
    customControls={customFormControls}
    renderDefaultControls={false}
    isPrintable={false}
  />;
}

